import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/api.service';
import { Router, RouterStateSnapshot } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class CheckoutService {
  data:any;
  value:any;
    priceWeight: any[];
    total = {'weight':0,'price':0};
    constructor(private api:ApiService,private router:Router) {
      this.api.Cart.subscribe(data => {
        this.total = {'weight': 0,'price': 0};
        this.data = this.api.getCart();
         });
  
    }
    canActivate(route, state: RouterStateSnapshot) {
        this.total = {'weight': 0,'price': 0};
        this.data = this.api.getCart();
  
  
      if (this.data!=null)
      {
            return true;
      }
      else if(this.data==null)
      {         console.log(this.data);
                this.api.onFail("You don't have any Products for Checkout",'No Products');
                
                return false;
        }
        else
        {
          this.router.navigate(['/home']);
        }
    }
  }
